var map = {
	"./Anae/APACHE2.vue": "PCbC",
	"./Anae/ASA_AnesthesiaRisk.vue": "ToOE",
	"./Anae/ASCVD.vue": "jAkX",
	"./Anae/Aldrete.vue": "Mqmo",
	"./Anae/AllowableBloodLoss.vue": "4gy8",
	"./Anae/Anesthesia.vue": "Knjc",
	"./Anae/Charlson.vue": "sfsQ",
	"./Anae/Chart_Bromage.vue": "AnUb",
	"./Anae/Chart_BromageModified.vue": "T2OE",
	"./Anae/Chart_Mallampati.vue": "spwy",
	"./Anae/CormackLehane.vue": "CeWg",
	"./Anae/Criteria_for_rating_the_effect_of_general_anesthesia.vue": "U1Wt",
	"./Anae/DeltaPP.vue": "Ss0D",
	"./Anae/Detsky.vue": "xq2c",
	"./Anae/Goldman.vue": "zqe3",
	"./Anae/IVDripRate.vue": "/i7U",
	"./Anae/InhalationOfGeneralAnesthesia.vue": "YHYo",
	"./Anae/Lee.vue": "FCFg",
	"./Anae/PADSS.vue": "hU4q",
	"./Anae/Possum.vue": "0Hys",
	"./Anae/PrinceHenry.vue": "iUK8",
	"./Anae/RSBI.vue": "Vd7U",
	"./Anae/SpinalAnesthesia.vue": "dasT",
	"./Anae/Steward.vue": "K+f4",
	"./Anae/TASH.vue": "LnYc",
	"./Card/ABCD2.vue": "OkM8",
	"./Card/ABCD2SCORE.vue": "/ZM2",
	"./Card/Activated_Partial_Thromboplastin_Time.vue": "jHSW",
	"./Card/AcuteLowerLimbIschemia.vue": "DE9t",
	"./Card/Aortic_aneurysm.vue": "Ogv/",
	"./Card/ApoB.vue": "BZ40",
	"./Card/Apo_A_1.vue": "k2Hw",
	"./Card/Aspartate_Aminotransferase.vue": "AA7V",
	"./Card/AtrialFibrillationSymptomScore.vue": "g+if",
	"./Card/Atrial_fibrillation.vue": "axhA",
	"./Card/BODEXINDEX.vue": "KT6u",
	"./Card/BorgCR10.vue": "nSc/",
	"./Card/BorgDyspneaScore.vue": "LvEC",
	"./Card/CHA2DS2VASc.vue": "94aZ",
	"./Card/CHADS2.vue": "JkXp",
	"./Card/CK_MB_Activity.vue": "a6YW",
	"./Card/CK_MB_Mass.vue": "sFEj",
	"./Card/CRUSADE.vue": "lIaP",
	"./Card/Cardiac_Troponin_I.vue": "Mn6b",
	"./Card/Cardiac_Troponin_T.vue": "VYZw",
	"./Card/Chart_CCSAngina.vue": "tTSj",
	"./Card/Chart_Killip.vue": "ul7t",
	"./Card/Chart_NYHA.vue": "Opz7",
	"./Card/Cysteine.vue": "qV+w",
	"./Card/DanielECG.vue": "jHd3",
	"./Card/Digitoxin.vue": "IB9r",
	"./Card/Digoxin.vue": "xFkT",
	"./Card/DukeDiagnosticCriteria.vue": "Zz4k",
	"./Card/FraminghamCHDRisk.vue": "JGGy",
	"./Card/GestationalHypertension.vue": "OngA",
	"./Card/Glycine.vue": "9Uq4",
	"./Card/HFMUSICRISKSCORE.vue": "8mBI",
	"./Card/HFVALIANTRISKSCORE.vue": "Lvih",
	"./Card/High_Density_Lipoprotein_Cholesterol.vue": "ZB9c",
	"./Card/ICVDTYF.vue": "6pmn",
	"./Card/IFTPRC.vue": "Rdln",
	"./Card/LP_a.vue": "kGNU",
	"./Card/Lactate_Dehydrogenase.vue": "PgFm",
	"./Card/Low_Density_Lipoprotein_Cholesterol.vue": "de4X",
	"./Card/Myoglobin.vue": "DPEW",
	"./Card/N1_methylnicotinamide.vue": "w0G7",
	"./Card/N_Acetylprocainamide.vue": "BSeI",
	"./Card/N_terminal_pro_B_type_natriuretic_peptide.vue": "kYCk",
	"./Card/PROCAMScore.vue": "iogp",
	"./Card/PTSVILLALTASCORE.vue": "Kmyu",
	"./Card/SAMS_CI.vue": "YwX9",
	"./Card/SCORE_Risk_Charts.vue": "TDpi",
	"./Card/SEPSISSIRS1.vue": "0H85",
	"./Card/Salicylate.vue": "IF3O",
	"./Card/ShockIndex.vue": "oEfl",
	"./Card/TASCAORTOILIAC.vue": "Oscr",
	"./Card/TASCFEMORALPOPLITEAL.vue": "cuUo",
	"./Card/Triglycerides.vue": "AvSg",
	"./Card/VTEDASHSCORE.vue": "mOab",
	"./Card/WARFARINELDERLY.vue": "XlP+",
	"./Card/WalkingTestDistance6.vue": "/LeZ",
	"./Card/WarfarinDose.vue": "iz5L",
	"./Card/WellsDVT.vue": "D7Dp",
	"./Card/WellsPE.vue": "te3M",
	"./Card/WellsPE2.vue": "+bMu",
	"./Common/25_Hydroxyvitamin_D.vue": "fZkM",
	"./Common/AABDOCAAA.vue": "4qLj",
	"./Common/AAST_liver_trauma_classification.vue": "fkn3",
	"./Common/ABPOCAAA.vue": "tP4Z",
	"./Common/ACOAD.vue": "WsO5",
	"./Common/ACONF.vue": "DSaF",
	"./Common/ADH.vue": "IEI3",
	"./Common/ADL.vue": "ev5w",
	"./Common/ADOindex.vue": "Nu6s",
	"./Common/AEROPPD.vue": "AZls",
	"./Common/AFP.vue": "OV01",
	"./Common/ANC.vue": "vByv",
	"./Common/AO.vue": "gTWx",
	"./Common/APACHE_two.vue": "68a9",
	"./Common/ARFOCAAA.vue": "tswp",
	"./Common/ASIA__.vue": "ol4+",
	"./Common/AVAROHRICOAA.vue": "3A9P",
	"./Common/Acne.vue": "kOtV",
	"./Common/AndersonClassificationOfOpenFractures.vue": "c7ly",
	"./Common/AnemiaClassification.vue": "alRj",
	"./Common/Apfel.vue": "2/sR",
	"./Common/Ascorbic_Acid.vue": "lpaq",
	"./Common/BUN.vue": "99ua",
	"./Common/Bado_classification_of_Montessori_fracture.vue": "tdbK",
	"./Common/Bicarbonate.vue": "Cjfp",
	"./Common/Biotin.vue": "s/4t",
	"./Common/Blood_Platelet.vue": "lcIf",
	"./Common/CATOLCUIC.vue": "j0gD",
	"./Common/CFSC.vue": "2C14",
	"./Common/COBPL.vue": "7kxF",
	"./Common/CROIBPCICOAA.vue": "wb9r",
	"./Common/CSFWBCCIBC.vue": "I5Ct",
	"./Common/CTOFACSIC.vue": "p7V1",
	"./Common/CVC.vue": "H9Fz",
	"./Common/C_reactive_protein.vue": "0LGz",
	"./Common/CaO.vue": "ThJ7",
	"./Common/Caprini.vue": "KxUS",
	"./Common/Carpal_tunnel_syndrome.vue": "y0hC",
	"./Common/Charlson_Index.vue": "lECR",
	"./Common/Children_bacterial_meningitis_score.vue": "4TbV",
	"./Common/ChillsGraded.vue": "aEUa",
	"./Common/Chronic_tension_type_headaches.vue": "7HB1",
	"./Common/Classification_of_medial_epicondyle_fractures_of_the_humerus.vue": "E/pE",
	"./Common/Codman_classification_of_proximal_humeral_fractures.vue": "yNc9",
	"./Common/Colorectal_carcinoma.vue": "qzKK",
	"./Common/ControlObjectivesOfType2DiabetesInChina.vue": "4/vn",
	"./Common/CrichtonRoyalBehavioralRatingScale.vue": "ca3B",
	"./Common/CriteriaOfNFIAndNFII.vue": "di/k",
	"./Common/DARTISC.vue": "HgsH",
	"./Common/DBDACD.vue": "58k8",
	"./Common/DBPVACVV.vue": "368h",
	"./Common/DBTBPAFBP.vue": "xUuC",
	"./Common/DCACGOHINHIE.vue": "uDOr",
	"./Common/DCOIDIC.vue": "LNtU",
	"./Common/DCOLPIC.vue": "uCI+",
	"./Common/DCOOF.vue": "Hoj/",
	"./Common/DCOPD.vue": "5F/P",
	"./Common/DDOVTOIH.vue": "n6jA",
	"./Common/DGOSD.vue": "wbAf",
	"./Common/DWTAEPD.vue": "gqmI",
	"./Common/DanisWeber.vue": "2r/R",
	"./Common/DeltaGap.vue": "ywgM",
	"./Common/DenisClassificationOfBurstFracture.vue": "qISr",
	"./Common/DermatomeMapDifferent.vue": "J5FS",
	"./Common/Detsky_Index.vue": "WsZP",
	"./Common/DiagnosticCriteriaForCrohnsDisease.vue": "GMO2",
	"./Common/DiagnosticCriteriaForNMO.vue": "iJWV",
	"./Common/DiagnosticCriteriaForPelvicInflammatoryDisease.vue": "BZtX",
	"./Common/Diseaseactivityscorein28joints.vue": "9dxt",
	"./Common/Distal_bile_duct_carcinoma.vue": "Iwpi",
	"./Common/DukesClassification.vue": "LsWI",
	"./Common/E3.vue": "YMoV",
	"./Common/EHRAscore.vue": "MYLg",
	"./Common/EIlis.vue": "jCzD",
	"./Common/EPDS.vue": "CLs7",
	"./Common/ESRS.vue": "3Xcn",
	"./Common/ElbowCassebaumScoringSystem.vue": "5B2A",
	"./Common/Emergency_Contraception_Pills_Dosage_and_Protocol.vue": "0vzL",
	"./Common/EnergyConversion.vue": "Jgn9",
	"./Common/EvidenceForHpEradication.vue": "rl4A",
	"./Common/EyresBrooks.vue": "tNgy",
	"./Common/FAS_Cr_Cys.vue": "zRMh",
	"./Common/FCI.vue": "0Rwm",
	"./Common/FCODRF.vue": "bIXW",
	"./Common/FFM.vue": "o7Gz",
	"./Common/FIM.vue": "OohN",
	"./Common/FONTAINEANDRUTHERFORD.vue": "Noyi",
	"./Common/FPTC.vue": "ZuSG",
	"./Common/Fluid_in_the_tympanum.vue": "kOGo",
	"./Common/Folate.vue": "D/Nh",
	"./Common/Folic_Acid.vue": "9Lot",
	"./Common/ForrestClassification.vue": "CZdZ",
	"./Common/Fracture_AO_classification.vue": "MxdB",
	"./Common/Fructose.vue": "46FQ",
	"./Common/FrykmanClassificationOfDistalRadiusFractures.vue": "y6UH",
	"./Common/GCOFOTFMB.vue": "Cjxf",
	"./Common/GCOSFOH.vue": "VIIO",
	"./Common/Gamma_Light_Chain.vue": "TrR0",
	"./Common/Gastric_cancer.vue": "CjFN",
	"./Common/Gastrin_unit_conversion.vue": "Owbl",
	"./Common/Gentamicin.vue": "xLEw",
	"./Common/Glucksberg.vue": "+2tl",
	"./Common/Glutamine.vue": "zg88",
	"./Common/Goldman_Index.vue": "RBDr",
	"./Common/HAD.vue": "5DcZ",
	"./Common/HCT.vue": "y82Z",
	"./Common/HDSS.vue": "vaMq",
	"./Common/HDSS1.vue": "w5wV",
	"./Common/Hemoglobin_A1c.vue": "KkJc",
	"./Common/Hepatitis_B_five.vue": "4tiV",
	"./Common/Herbert_classification_of_scaphoid_fracture.vue": "NSBo",
	"./Common/Histidine.vue": "kUis",
	"./Common/HormoneDoseConversion.vue": "OGA3",
	"./Common/HumanFun.vue": "5Uqa",
	"./Common/Hunt_Hess.vue": "q4EU",
	"./Common/HypertonicDehydrationRehydrationVolume.vue": "N1Mj",
	"./Common/IAPOMVFCND.vue": "JbI2",
	"./Common/IETTHCriteria.vue": "AtH4",
	"./Common/IL_six.vue": "t0rO",
	"./Common/ILinChildren.vue": "shHi",
	"./Common/IOTOMP.vue": "/SHv",
	"./Common/ISSVD_classification.vue": "pxFA",
	"./Common/ISTHNONOVERTDIC.vue": "nE1D",
	"./Common/ISTHSSCDIC.vue": "oqni",
	"./Common/Ideal_height_prediction_formula.vue": "MsGO",
	"./Common/IdebergClassificationOfIntraglenoidFractures.vue": "a9TO",
	"./Common/IdentificationofRaynaudDiseaseandRaynaudPhenomenon.vue": "mnJI",
	"./Common/IgA.vue": "NEU4",
	"./Common/IgE.vue": "ErUB",
	"./Common/ImprovedAndSimplified_MDRD.vue": "brAw",
	"./Common/ImprovedBarkovichHIEMRI.vue": "NC27",
	"./Common/InslerCervicalEstrogenLevelScoringMethod.vue": "4mNb",
	"./Common/International_Index_of_Erectile_Function.vue": "CQea",
	"./Common/IntracranialHemorrhageVolume.vue": "fhKf",
	"./Common/JulianGradingMethodForVaginalCurvatureAndProtrusion.vue": "FRts",
	"./Common/KPOTDDCFVD.vue": "k++J",
	"./Common/Karlsson_postoperative_efficacy_scoring_criteria.vue": "P1et",
	"./Common/KhoranaRiskScore.vue": "F9Jx",
	"./Common/Knee_fracture.vue": "rold",
	"./Common/LBP.vue": "4HX1",
	"./Common/LLDOCM.vue": "NPK4",
	"./Common/LVFUNCTION.vue": "2YX9",
	"./Common/LaboratoryExaminationItemsAndResultsOfThyroidFunctionDuringPregnancy.vue": "zKpv",
	"./Common/Langerhans_cell_histiocytosis.vue": "BeQ1",
	"./Common/Lauge_Hansen.vue": "CmkV",
	"./Common/Lee_.vue": "FFX6",
	"./Common/Lidocaine.vue": "epMf",
	"./Common/Lipid_unit_conversion.vue": "UhNP",
	"./Common/Lund_Mackay.vue": "+lay",
	"./Common/Lupus_nephritis.vue": "eeLq",
	"./Common/Lysine.vue": "jqmF",
	"./Common/MABL.vue": "l2vm",
	"./Common/MAGIC.vue": "HpMF",
	"./Common/MCOSF.vue": "5DdQ",
	"./Common/MEWS.vue": "4Kh9",
	"./Common/MalinasScore.vue": "jKpu",
	"./Common/ManningFetalBiophysica_MonitoringScoreAndProcessingPrinciples.vue": "hnYU",
	"./Common/MayoScore.vue": "Tqit",
	"./Common/Mechanical_Ventilation.vue": "0Qex",
	"./Common/MenopausalRatingScale.vue": "GaPF",
	"./Common/Methanol.vue": "M51t",
	"./Common/Methionine.vue": "SCat",
	"./Common/Modified_Evans_classification_of_intertrochanteric_fractures.vue": "neDw",
	"./Common/Morisky.vue": "yxiv",
	"./Common/Morse.vue": "IR6t",
	"./Common/MortalityInOlderAdultsAfterHospitalization.vue": "7Xi3",
	"./Common/MultipleSclerosis.vue": "KrlJ",
	"./Common/Myelodysplastic_syndrome.vue": "PkPx",
	"./Common/NACA.vue": "AwEP",
	"./Common/NEUT.vue": "FWZ1",
	"./Common/NMONADGA.vue": "WGJn",
	"./Common/NRS.vue": "HQix",
	"./Common/NUTRIC.vue": "8YIG",
	"./Common/Na.vue": "X+ZU",
	"./Common/NaCl.vue": "bqYY",
	"./Common/Naranjo.vue": "mID1",
	"./Common/Neuroendocrine_tumors_of_the_colon_and_rectum.vue": "pW4y",
	"./Common/NewOrleansCriteria.vue": "HaV7",
	"./Common/Niacin.vue": "CrDU",
	"./Common/Normal_lochia_trait.vue": "Idos",
	"./Common/NugentScoringCriteriaForGramStainingOfVaginalSecretions.vue": "jP6y",
	"./Common/OAA_S.vue": "0juH",
	"./Common/Osserman.vue": "g82m",
	"./Common/Osteocalcin.vue": "4nI4",
	"./Common/Ottawa_ankle_rules.vue": "bKjG",
	"./Common/OxygenDeliveryMethodAndConcentration.vue": "4N3a",
	"./Common/PELD_score.vue": "iGz6",
	"./Common/PHWHOFC.vue": "BkaE",
	"./Common/PNFLRINEC.vue": "69BE",
	"./Common/POP_QStagingEvaluationIndicatorPointForPelvicOrganProlapse.vue": "2huO",
	"./Common/POP_Q_staging.vue": "kReK",
	"./Common/POSSUMandPPOSSUM.vue": "Rnns",
	"./Common/PRAMSCORE.vue": "J4Sp",
	"./Common/Pantothenic_Acid.vue": "8Lu0",
	"./Common/ParkinsonsDiseaseCriteria.vue": "eh2w",
	"./Common/Pelvis_Tile_classification.vue": "dHSg",
	"./Common/Perilunate_dislocation_stage.vue": "0JPA",
	"./Common/PerioperativeHighriskCriteria.vue": "KNIm",
	"./Common/PisaPE.vue": "R79m",
	"./Common/Placental_Growth_Factor.vue": "7nNm",
	"./Common/PlasmaOsmoticPressure.vue": "h6PX",
	"./Common/Pleural_mesothelioma.vue": "03xb",
	"./Common/Posterior_dislocation_of_shoulder.vue": "W9ga",
	"./Common/Predicting_Height_From_KH.vue": "eMHq",
	"./Common/Prognostic_evaluation_of_myelodysplastic_syndrome.vue": "J8Lj",
	"./Common/PulmonaryEmbolismSeverity.vue": "yslO",
	"./Common/Pyridoxine.vue": "1Fjw",
	"./Common/Pyrrolysine.vue": "Q1IP",
	"./Common/RBC_UnitConversion.vue": "MJcm",
	"./Common/RBRHAABOH.vue": "htlU",
	"./Common/RDR.vue": "eSLk",
	"./Common/RF.vue": "zz5X",
	"./Common/RFAHAJONES.vue": "9tuy",
	"./Common/ROSIERSIGLE.vue": "zVZI",
	"./Common/RPI.vue": "Gz6D",
	"./Common/RQ.vue": "NvQj",
	"./Common/RSFNPN.vue": "jN/N",
	"./Common/RanchoLosAmigos.vue": "N5bi",
	"./Common/Regan_classification_of_ulnar_coronoid_process_fractures_of_the_elbow.vue": "zgpL",
	"./Common/ReidColposcopicIndex.vue": "N0SC",
	"./Common/Ret.vue": "Ggdl",
	"./Common/Riboflavin.vue": "oDvv",
	"./Common/Rutherford_classification_of_lower_limb_arteriosclerosis_obliterans.vue": "QUR9",
	"./Common/SADTOOIPFC.vue": "bRjU",
	"./Common/SAPS_two.vue": "RXev",
	"./Common/SASOLDH.vue": "vhDp",
	"./Common/SCON.vue": "Abnn",
	"./Common/SFAONS.vue": "K/G9",
	"./Common/SHBG.vue": "RVkk",
	"./Common/SMARTCOP.vue": "CO+D",
	"./Common/SNSS.vue": "MR9U",
	"./Common/SOTIM.vue": "QbnE",
	"./Common/STRATIFY.vue": "K8z3",
	"./Common/Sacroiliac_joint_disorder.vue": "6HJQ",
	"./Common/SalterHarrisClassification.vue": "MRum",
	"./Common/Scapholunate_instability.vue": "NXQg",
	"./Common/Selenocysteine.vue": "0Xel",
	"./Common/Serum_permeation_gap.vue": "g/9u",
	"./Common/Shizgal_Rosa.vue": "JhQ2",
	"./Common/Soft_tissue_sarcoma_of_extremities_and_trunk.vue": "mbre",
	"./Common/Spinal_cord_injury_Frankel_functional_class_ASIA_class.vue": "MuRB",
	"./Common/Spondyloarthropathies.vue": "Qw37",
	"./Common/SunderlandClassificationOfNerveInjury.vue": "Av3p",
	"./Common/Systemic_lupus_erythematosus_activity_score.vue": "CM9v",
	"./Common/TAOWAERFVLF.vue": "H6yV",
	"./Common/TBS_classification.vue": "oroQ",
	"./Common/TC.vue": "uC9u",
	"./Common/TCOSI.vue": "lzW4",
	"./Common/TIBC.vue": "pKX+",
	"./Common/TOOIASTT.vue": "rzDn",
	"./Common/TP1NP.vue": "FHfD",
	"./Common/TPCOR.vue": "8Veo",
	"./Common/TPN.vue": "IzHH",
	"./Common/TRF.vue": "QGF6",
	"./Common/Teeth_order_in_children.vue": "NEGA",
	"./Common/The_height_of_the_uterine_fundus_and_the_length_of_the_uterus_at_different_gestational_weeks.vue": "mMdy",
	"./Common/Thiamine.vue": "8fUn",
	"./Common/Threonine.vue": "ScLS",
	"./Common/Tobramycin.vue": "ANWH",
	"./Common/TopiramateDosageMethod.vue": "VX5U",
	"./Common/Total_Vitamin_D.vue": "9y66",
	"./Common/TrueloveAndWittsCriteria.vue": "WN2Z",
	"./Common/Tryptophan.vue": "IX26",
	"./Common/Tscheme.vue": "8DIE",
	"./Common/Unit_conversion_of_common_ions.vue": "OvK0",
	"./Common/Urea_unit_conversion.vue": "FRXO",
	"./Common/UrineOutput.vue": "zf1z",
	"./Common/VAS.vue": "0C4t",
	"./Common/Val.vue": "3Nw4",
	"./Common/Vancomycin.vue": "Epke",
	"./Common/VbacRiskScoreForVaginalDelivery.vue": "2Vfq",
	"./Common/VisceralTractionReaction.vue": "e8Tg",
	"./Common/Vitamin_E.vue": "Ik5c",
	"./Common/WBC_UnitConversion.vue": "uhzu",
	"./Common/WFNSCOSAH.vue": "17/O",
	"./Common/WHO_HumanSemen.vue": "HRDS",
	"./Common/WHO_UMC.vue": "9P3M",
	"./Common/WYCOOF.vue": "I5Wz",
	"./Common/WaterDeficit.vue": "Ho7N",
	"./Common/WestHavenScore.vue": "taMh",
	"./Common/ZDSC.vue": "GLLA",
	"./Common/albumin.vue": "/2SL",
	"./Common/ammonia.vue": "hzyk",
	"./Common/bromhidrosis.vue": "GOet",
	"./Common/classification_and_classificationof_OHSS.vue": "P3ki",
	"./Common/clinical_classification_of_vulvovaginal_candidiasis.vue": "nPNT",
	"./Common/clinical_manifestations_scoring_criteria_for_vulvovaginal_candidiasis.vue": "uAeP",
	"./Common/criteria_of_CH.vue": "pnaP",
	"./Common/diagnosis_of_severe_pre_eclampsia.vue": "FeBk",
	"./Common/epidural_anaesthesia.vue": "q5gr",
	"./Common/estradiol.vue": "n7a/",
	"./Common/ethanol.vue": "GxkY",
	"./Common/fetal_developmental_index.vue": "96CI",
	"./Common/fetal_maturity_test.vue": "Q02U",
	"./Common/halfway_system.vue": "6FEr",
	"./Common/lle.vue": "Z58b",
	"./Common/open_fractrue.vue": "L+B8",
	"./Common/open_fracture_gustilo.vue": "vdc6",
	"./Common/p_AMY.vue": "qC8P",
	"./Common/p_C_telopeptides_of_type_I_collagen.vue": "DLSc",
	"./Common/the_MOS_item_short_from_health_survey.vue": "z3vz",
	"./Common/the_impact_of_commonly_used_pregnant_women_medication_on_the_fetus.vue": "25dM",
	"./Common/the_location_and_common_diseases_of_abdominal_masses.vue": "LOjC",
	"./Common/the_relationship_between_the_degree_of_hyperthyroidism_during_pregnancy_and_medication_dosage.vue": "Iy6x",
	"./Common/tri_line.vue": "6B65",
	"./Common/βHCG.vue": "JiA1",
	"./DS/BI_RADS.vue": "I4D0",
	"./DS/OvarianCancer_TNM.vue": "qIia",
	"./DS/ProstateCancer_TNM.vue": "rKXL",
	"./Diab/Calvert.vue": "wD5q",
	"./ER/Chart_ASA.vue": "Pvji",
	"./ER/Chart_CormackLehane.vue": "GRdD",
	"./ER/Chart_RASS.vue": "OSBA",
	"./ER/Chart_Ramsay.vue": "KAa+",
	"./ER/Chart_Rudkin.vue": "0u0A",
	"./ER/FluidRepletionAfterBurns.vue": "0HHC",
	"./ER/NIH.vue": "UYut",
	"./ER/OttawaSAH.vue": "upjX",
	"./ER/ROSIER.vue": "s0Ms",
	"./ER/Rockall.vue": "XysB",
	"./ER/SAS.vue": "7rtC",
	"./Endocrine/17_α_hydroxy_progesterone.vue": "u+D7",
	"./Endocrine/ACAC.vue": "eVZ3",
	"./Endocrine/Acetone.vue": "eP1O",
	"./Endocrine/Alanine.vue": "2eXx",
	"./Endocrine/Aldosterone.vue": "riYD",
	"./Endocrine/Androstenedione.vue": "Hy5x",
	"./Endocrine/Anti_Mullerian_Hormone.vue": "9CsS",
	"./Endocrine/Anti_Thyroglobulin_Antibodies.vue": "wJQt",
	"./Endocrine/Antidiuretic_Hormone.vue": "kSlY",
	"./Endocrine/Bicarbonate_deficiency.vue": "2Vkd",
	"./Endocrine/C_Peptide.vue": "/oKM",
	"./Endocrine/Calcitonin.vue": "1ZLR",
	"./Endocrine/Calcitriol.vue": "mU6E",
	"./Endocrine/Calcium.vue": "tplm",
	"./Endocrine/ClassificationOfGoiter.vue": "0jAa",
	"./Endocrine/Congenital_HYP.vue": "qOMY",
	"./Endocrine/DR.vue": "3kQG",
	"./Endocrine/Dehydroepiandrosterone_Sulfate.vue": "txNe",
	"./Endocrine/DiabeticFeet.vue": "CcCK",
	"./Endocrine/DiagnosticCriteriaForDM.vue": "DrS8",
	"./Endocrine/FT3.vue": "/05t",
	"./Endocrine/FT4.vue": "sknK",
	"./Endocrine/Fructosamine.vue": "E287",
	"./Endocrine/GDM.vue": "dObK",
	"./Endocrine/GDMWhite.vue": "NsEA",
	"./Endocrine/Glucagon.vue": "b+my",
	"./Endocrine/Glucose.vue": "kTP/",
	"./Endocrine/Glycosylated_hemoglobin_target.vue": "7TUA",
	"./Endocrine/GravesCAS.vue": "PizN",
	"./Endocrine/GravesOCC.vue": "MS4s",
	"./Endocrine/HHS.vue": "qu0F",
	"./Endocrine/HOMA_IR.vue": "TftM",
	"./Endocrine/HSCCF.vue": "Sa9D",
	"./Endocrine/HbA1c.vue": "iC/1",
	"./Endocrine/Human_Chorionic_Gonadotropin.vue": "xEdA",
	"./Endocrine/Human_Growth_Hormone.vue": "7zee",
	"./Endocrine/IGFBP_3.vue": "IFPC",
	"./Endocrine/IGF_1.vue": "b0pr",
	"./Endocrine/IdealWeight_dailyEnergy.vue": "rF0e",
	"./Endocrine/Insulin_Unit_Conversion.vue": "4b6J",
	"./Endocrine/Lactic_Acid.vue": "dgx1",
	"./Endocrine/Leucine.vue": "si19",
	"./Endocrine/MSDC.vue": "CUA4",
	"./Endocrine/Macroprolactin.vue": "BAiC",
	"./Endocrine/Microalbuminuria.vue": "J4zv",
	"./Endocrine/Oral_glucose_tolerance_test.vue": "/x8y",
	"./Endocrine/PancreaticCancer_TNM.vue": "31TO",
	"./Endocrine/Pharmacological_treatment_of_type_2_diabetes.vue": "pSXb",
	"./Endocrine/Physical_Activity_Schedule_for_People_with_Diabetes.vue": "an6P",
	"./Endocrine/Plasma_Volume.vue": "iQyt",
	"./Endocrine/Potassium.vue": "6tna",
	"./Endocrine/Prolactin.vue": "CPm4",
	"./Endocrine/Prostate_Specific_Antigen.vue": "bznu",
	"./Endocrine/Retinol.vue": "nr9f",
	"./Endocrine/RiskAssessment.vue": "C7aS",
	"./Endocrine/SMBG.vue": "hfRn",
	"./Endocrine/Serine.vue": "YNjt",
	"./Endocrine/SexualDevelopment.vue": "ny7y",
	"./Endocrine/TSHR_antibodies.vue": "JfOF",
	"./Endocrine/Thyroglobulin.vue": "fof2",
	"./Endocrine/Thyroid_Stimulating_Hormone.vue": "1oAd",
	"./Endocrine/Thyroid_Uptake.vue": "77Ay",
	"./Endocrine/Thyroxine_binding_Globulin.vue": "R7v2",
	"./Endocrine/Total_Thyroxine.vue": "uqaY",
	"./Endocrine/Triiodothyronine.vue": "TqwR",
	"./Endocrine/Type_2_Diabetes_Control_Goals.vue": "YpKy",
	"./Endocrine/Tyrosine.vue": "0U3N",
	"./Endocrine/adrenocorticotropic_hormone.vue": "qvGd",
	"./Endocrine/p_Hydroxybutyrate.vue": "nxge",
	"./Endocrine/parathyroid_hormone.vue": "4XcB",
	"./GD/ABIC.vue": "Kqpa",
	"./GD/APRI.vue": "D5Kj",
	"./GD/AnionGapSerum.vue": "A0rx",
	"./GD/BISAP.vue": "1YFM",
	"./GD/BalthazarCT.vue": "NcdT",
	"./GD/BristolStool.vue": "GZx4",
	"./GD/EndStageLiverDisease.vue": "o9Su",
	"./GD/GERDGrading.vue": "ml4P",
	"./GD/MarshallScoringSystem.vue": "HTKy",
	"./GD/PEN.vue": "l17e",
	"./GD/PanNeuTumor.vue": "QCJS",
	"./GD/ProteinIntake.vue": "orTZ",
	"./GD/Rutgeerts.vue": "i0Br",
	"./GD/StoolOsmoticGap.vue": "YZ1c",
	"./GD/TNMStaging.vue": "1e5L",
	"./GIT/ACCR.vue": "9lL/",
	"./GIT/Amylase.vue": "otcs",
	"./GIT/BalthazarCTModified.vue": "qaqL",
	"./GIT/CDAI.vue": "O4OI",
	"./GIT/CIWAArScore.vue": "qz2x",
	"./GIT/Chart_Forrest.vue": "Ar/S",
	"./GIT/Colorectal_polyp.vue": "ccSO",
	"./GIT/Eckardt.vue": "F6Kj",
	"./GIT/GlasgowBlatchford.vue": "vu7r",
	"./GIT/GlasgowSystem.vue": "oBsi",
	"./GIT/HRAR.vue": "BDJc",
	"./GIT/HarveyBradshawIndex.vue": "UdQB",
	"./GIT/Hinchey.vue": "2qGy",
	"./GIT/HpInfectionEradicationCriteria.vue": "SUwa",
	"./GIT/LPS.vue": "QLCe",
	"./GIT/NonalcoholicFattyLiver.vue": "Kg01",
	"./GIT/Ranson.vue": "CLJF",
	"./HD/MM_DS.vue": "okgj",
	"./HD/MM_ISS.vue": "2QmG",
	"./HD/MM_R_ISS.vue": "9Wsk",
	"./HD/PCL.vue": "QwQ6",
	"./Hema/APCCI.vue": "rtZi",
	"./Hema/AcuteMyeloidLeukemia.vue": "5tLB",
	"./Hema/Acute_myeloid_leukaemia.vue": "8KG1",
	"./Hema/Antithrombin_three.vue": "3VHX",
	"./Hema/Arginine.vue": "1yOQ",
	"./Hema/ChronicLymphocyticLeukemia_Binet.vue": "5f9+",
	"./Hema/ChronicLymphocyticLeukemia_RAI.vue": "kugj",
	"./Hema/Erythropoietin.vue": "WrDg",
	"./Hema/HBG.vue": "XrKo",
	"./Hema/HITFourTsScore.vue": "ffHH",
	"./Hema/Hemoglobin_subunit.vue": "qAPW",
	"./Hema/Hemoglobin_tetramer.vue": "66oy",
	"./Hema/Isopropanol.vue": "CJJN",
	"./Hema/Magnesium.vue": "vcFD",
	"./Hema/Mean_Corpuscular_Hemoglobin.vue": "+tlO",
	"./Hema/Mean_Corpuscular_Hemoglobin_Concentration.vue": "a9RB",
	"./Hema/Mean_Corpuscular_Volume.vue": "GF/W",
	"./Hema/Mean_Platelet_Volume.vue": "CgTb",
	"./Hema/Phylloquinone.vue": "VDPV",
	"./Hema/Prothrombin_Time.vue": "Pq01",
	"./Hema/Red_Cell_Distribution_Width.vue": "mHob",
	"./Hema/Red_Cell_Distribution_Width_Standard_Deviation.vue": "vvsO",
	"./Hema/Soluble_Transferrin_Receptor.vue": "y4rJ",
	"./Hema/TP.vue": "3uLN",
	"./Hema/Thrombin_Time.vue": "dpjc",
	"./Hema/TransferrinSaturation.vue": "f5ww",
	"./Hepatology/Alanine_Aminotransferase.vue": "hH+k",
	"./Hepatology/Alkaline_Phosphatase.vue": "dySe",
	"./Hepatology/Cholinesterase.vue": "hD7P",
	"./Hepatology/Cystatin_C.vue": "+CHL",
	"./Hepatology/DBIL.vue": "AREa",
	"./Hepatology/Fibrinogen.vue": "W4O8",
	"./Hepatology/Gamma_Glutamyl_Transferase.vue": "kjvj",
	"./Hepatology/Glutamate_Dehydrogenase.vue": "h2pW",
	"./Hepatology/Haptoglobin.vue": "QP0J",
	"./Hepatology/LilleModel.vue": "p75Z",
	"./Hepatology/Prealbumin.vue": "tArL",
	"./Hepatology/Proline.vue": "dN73",
	"./Hepatology/TBIL.vue": "ks5Z",
	"./Hepatology/Unsaturated_Iron_Binding_Capacity.vue": "fBw2",
	"./Hepatology/a1_antitrypsin.vue": "IJGt",
	"./ID/AbsoluteNeutrophilCount.vue": "DUtX",
	"./ID/Anti_Streptolysin_O.vue": "K3me",
	"./ID/CPIS.vue": "WhNp",
	"./ID/Candida.vue": "Wj0/",
	"./ID/CentorMcIsaac.vue": "lzKF",
	"./ID/Chart_Peritonitis.vue": "lEdB",
	"./ID/DukeCriteria.vue": "BkUr",
	"./ID/ISTH_DIC_non_overt.vue": "m0kk",
	"./ID/ISTH_DIC_overt.vue": "SA5c",
	"./ID/Jones.vue": "0AWA",
	"./ID/LRINEC.vue": "6GHr",
	"./ID/Marshall.vue": "dlbI",
	"./ID/PIROCAP.vue": "xHTf",
	"./ID/PIROVAP.vue": "42eK",
	"./ID/PSS.vue": "t98K",
	"./ID/Procalcitonin.vue": "1NsN",
	"./ID/SIRS.vue": "FbUY",
	"./ID/Sepsis3.vue": "+UGI",
	"./ID/qSOFA.vue": "8oEU",
	"./Neuro/AMTS.vue": "Cyga",
	"./Neuro/ASRAAOL.vue": "0qkv",
	"./Neuro/Acetaminophen.vue": "Iq2P",
	"./Neuro/Aldolase.vue": "Kq3B",
	"./Neuro/AphasiaClassification.vue": "v5kj",
	"./Neuro/Ashworth.vue": "W7Jg",
	"./Neuro/CTMRIfindingsofChiarimalformation.vue": "X9ww",
	"./Neuro/Carbamazepine.vue": "RwVv",
	"./Neuro/Carotid_Artery_Stenosis.vue": "0QHL",
	"./Neuro/CerebralPerfusionPressure.vue": "CVCl",
	"./Neuro/Chart_ASIA.vue": "RHvZ",
	"./Neuro/Chart_DermatomeMap.vue": "e9tS",
	"./Neuro/Chart_Fisher.vue": "eCEa",
	"./Neuro/Chart_GlasgowOutcomeScale.vue": "szYk",
	"./Neuro/Chart_HuntHess.vue": "WvOD",
	"./Neuro/Chart_ModifiedRankinScale.vue": "NERU",
	"./Neuro/Chart_MuscleStrength.vue": "eJF7",
	"./Neuro/Chart_WestHaven.vue": "VjoO",
	"./Neuro/Chiarimalformationclassification.vue": "PPfG",
	"./Neuro/China_Stroke_Scale.vue": "4pUY",
	"./Neuro/CincinattiStrokeScale.vue": "WX/q",
	"./Neuro/ClinicalDiagnosticCriteriaForAD.vue": "FKem",
	"./Neuro/Clinicalclassificationofmultiplesclerosis.vue": "SKFQ",
	"./Neuro/Cluster_headache.vue": "kM51",
	"./Neuro/Cobalamin.vue": "vk/I",
	"./Neuro/Creatine_Kinase.vue": "jbW/",
	"./Neuro/DN_four.vue": "EsGw",
	"./Neuro/DifferentialDiagnosisOfSpinalShockAndSpinalShock.vue": "kKDU",
	"./Neuro/FVC_EyeChart.vue": "3/pu",
	"./Neuro/Glutamic_Acid.vue": "HpM+",
	"./Neuro/HAMD.vue": "ztpi",
	"./Neuro/HIS.vue": "BP4m",
	"./Neuro/Homocysteine.vue": "fdDA",
	"./Neuro/InjuryOfTheSpinalCord.vue": "+W/V",
	"./Neuro/InternationalClassificationofHeadacheDisorders.vue": "NrMg",
	"./Neuro/MiniMentalStateExamination.vue": "YbqW",
	"./Neuro/NGASR.vue": "0DR1",
	"./Neuro/NIHSS.vue": "gVHe",
	"./Neuro/NeuropathicPainScale.vue": "y3jx",
	"./Neuro/PNSC.vue": "0AVH",
	"./Neuro/PVS.vue": "w9SM",
	"./Neuro/Phenobarbital.vue": "kNfg",
	"./Neuro/PittsburghBrainStemScore.vue": "2pi9",
	"./Neuro/S100_protein.vue": "zlRa",
	"./Neuro/SMCOIAM.vue": "zsKB",
	"./Neuro/SignsAndSymptomsOfCervicalNerveRootInvolvement.vue": "lGto",
	"./Neuro/Skeletalmusclestrengthtestingmethods.vue": "N8Et",
	"./Neuro/Spinal_disorders_of_different_sites.vue": "jzX/",
	"./Neuro/StrengthGrading.vue": "X8fI",
	"./Neuro/TIAScore.vue": "1Y5b",
	"./Neuro/TheOutcomeGradingOfGlasgow.vue": "Lu+v",
	"./Neuro/Valproic_acid.vue": "RXbU",
	"./Neuro/YoungManiaRatingScale.vue": "Yu2F",
	"./NewFormulas/ABBP.vue": "b9yw",
	"./NewFormulas/ABCD.vue": "h/L6",
	"./NewFormulas/AGED.vue": "yHT5",
	"./NewFormulas/ATRIA.vue": "89Qp",
	"./NewFormulas/A_G.vue": "kTtx",
	"./NewFormulas/Alvarado.vue": "gaqE",
	"./NewFormulas/BB.vue": "1z8q",
	"./NewFormulas/BMI.vue": "Xdpp",
	"./NewFormulas/BODE.vue": "CUhV",
	"./NewFormulas/Balthazar.vue": "el7U",
	"./NewFormulas/Braunwald.vue": "1j/W",
	"./NewFormulas/CAN.vue": "TmDK",
	"./NewFormulas/CCCH.vue": "KTTy",
	"./NewFormulas/CEF.vue": "cNRZ",
	"./NewFormulas/CFWDPH.vue": "imr/",
	"./NewFormulas/CLL_IPI.vue": "SKK7",
	"./NewFormulas/CO_Fick.vue": "2Ljp",
	"./NewFormulas/CO_ultrasound.vue": "AzA0",
	"./NewFormulas/CRUSADE.vue": "3sOE",
	"./NewFormulas/Child_Pugh.vue": "Wx/0",
	"./NewFormulas/DIA.vue": "o0Z0",
	"./NewFormulas/DO2.vue": "Yfir",
	"./NewFormulas/EKG.vue": "WXXN",
	"./NewFormulas/EORTC.vue": "3A4R",
	"./NewFormulas/Euro.vue": "ywjn",
	"./NewFormulas/FI.vue": "DX/R",
	"./NewFormulas/FIB_4.vue": "R40O",
	"./NewFormulas/FI_C.vue": "v02W",
	"./NewFormulas/FLACC.vue": "ygdB",
	"./NewFormulas/FLIPI_1.vue": "F2YS",
	"./NewFormulas/FLIPI_2.vue": "vTFJ",
	"./NewFormulas/FOF.vue": "qLBs",
	"./NewFormulas/Forrester.vue": "89V9",
	"./NewFormulas/Framingham.vue": "OatC",
	"./NewFormulas/GFR.vue": "UhDx",
	"./NewFormulas/GFRSchwartz.vue": "q8FH",
	"./NewFormulas/GFR_Cockcroft.vue": "2Moi",
	"./NewFormulas/GFR_Salazar.vue": "l52f",
	"./NewFormulas/GRACE.vue": "yUiN",
	"./NewFormulas/Gb.vue": "wx9D",
	"./NewFormulas/Geneva.vue": "h9Sy",
	"./NewFormulas/Glasgow.vue": "UYSY",
	"./NewFormulas/Gorlin.vue": "uOwQ",
	"./NewFormulas/HAS_BLED.vue": "fVlP",
	"./NewFormulas/HEART.vue": "79cM",
	"./NewFormulas/HEMORR.vue": "+DZw",
	"./NewFormulas/HP.vue": "5pCa",
	"./NewFormulas/Harris_Benedic.vue": "1IAh",
	"./NewFormulas/Hestia.vue": "OV0Z",
	"./NewFormulas/IBW.vue": "VClk",
	"./NewFormulas/IPI.vue": "82L3",
	"./NewFormulas/IPS.vue": "tESY",
	"./NewFormulas/LDL.vue": "64yZ",
	"./NewFormulas/LRVS.vue": "H+Iv",
	"./NewFormulas/L_T4.vue": "XtCc",
	"./NewFormulas/Levine6.vue": "7BfB",
	"./NewFormulas/Light.vue": "dfzr",
	"./NewFormulas/MAP.vue": "oqAf",
	"./NewFormulas/MASCC.vue": "5lvC",
	"./NewFormulas/MDRD.vue": "9Ie4",
	"./NewFormulas/Mannheim.vue": "9puf",
	"./NewFormulas/Mifflin.vue": "/OTv",
	"./NewFormulas/NEU.vue": "+kr9",
	"./NewFormulas/OBRI.vue": "fjpW",
	"./NewFormulas/PCI.vue": "33zD",
	"./NewFormulas/PDA.vue": "YOAN",
	"./NewFormulas/PERC.vue": "NxrZ",
	"./NewFormulas/PESI.vue": "PJ2j",
	"./NewFormulas/PREP.vue": "ragb",
	"./NewFormulas/PS.vue": "eERS",
	"./NewFormulas/Padua.vue": "W8I3",
	"./NewFormulas/Q_Tc.vue": "yNRF",
	"./NewFormulas/QpQs.vue": "La41",
	"./NewFormulas/RIETE.vue": "3quu",
	"./NewFormulas/RRF.vue": "dCRy",
	"./NewFormulas/Raw.vue": "GOpw",
	"./NewFormulas/RomanIndex.vue": "7veZ",
	"./NewFormulas/SOFA.vue": "+EOs",
	"./NewFormulas/STEMI_ECG.vue": "Skcu",
	"./NewFormulas/STOP_BANG.vue": "g+Ni",
	"./NewFormulas/SanFrancisco.vue": "qX1p",
	"./NewFormulas/TIMI.vue": "FEk3",
	"./NewFormulas/TIMI_NSTEMI.vue": "cXMM",
	"./NewFormulas/TIMI_STEMI.vue": "+Yv2",
	"./NewFormulas/UCE.vue": "aJMf",
	"./NewFormulas/VR.vue": "4MFP",
	"./NewFormulas/VRS.vue": "RgQe",
	"./NewFormulas/Vauthey.vue": "VOkH",
	"./NewFormulas/Winters.vue": "YkbI",
	"./NewFormulas/Zubrod.vue": "SBxv",
	"./NewFormulas/ad.vue": "aOJG",
	"./NewFormulas/ap.vue": "8rHw",
	"./NewFormulas/bosniak.vue": "fCu5",
	"./NewFormulas/bp.vue": "9c2q",
	"./NewFormulas/cas.vue": "FeqM",
	"./NewFormulas/chf.vue": "sSM8",
	"./NewFormulas/excrete.vue": "Igmh",
	"./NewFormulas/geneva1.vue": "tagQ",
	"./NewFormulas/he.vue": "kMze",
	"./NewFormulas/hemodynamics.vue": "lIuQ",
	"./NewFormulas/hepatitis.vue": "AIFH",
	"./NewFormulas/lc.vue": "OlIL",
	"./NewFormulas/serum.vue": "pM3V",
	"./NewFormulas/ssdh.vue": "iaK+",
	"./Nurse/Barthel.vue": "SgeU",
	"./Nurse/Chart_Bristol.vue": "LdC+",
	"./Nurse/Norton.vue": "cjxp",
	"./ObGyn/APGAR.vue": "zzhZ",
	"./ObGyn/Bishop.vue": "Uc4e",
	"./ObGyn/Chart_PainScale.vue": "FYjo",
	"./ObGyn/Follicle_Stimulating_Hormone.vue": "73YK",
	"./ObGyn/LMP.vue": "cwO5",
	"./ObGyn/Malinas.vue": "Kra6",
	"./ObGyn/PregnancyWeek.vue": "RNnm",
	"./ObGyn/Pregnancy_Associated_Plasma_Protein_A.vue": "ge7a",
	"./ObGyn/PremenstrualDysphoricDisorderDiagnosticCriteria.vue": "Ph8N",
	"./ObGyn/Progesterone.vue": "04K4",
	"./ObGyn/SI.vue": "FSR3",
	"./ObGyn/SilvermanAnderson.vue": "kNCi",
	"./ObGyn/Soluble_Fms_like_Tyrosine_Kinase_1.vue": "BpCO",
	"./Onco/AbdominalTumorRelatedMarkers.vue": "wX/S",
	"./Onco/Absolute_Eosinophil_Count.vue": "g6xQ",
	"./Onco/Acid_Phosphatase.vue": "hRrq",
	"./Onco/Adenocarcinoma_lacrimal.vue": "bDlI",
	"./Onco/Ampullary_carcinoma_of_Vater.vue": "MMAW",
	"./Onco/Anal_neoplasm.vue": "553r",
	"./Onco/Anatomical_staging_of_trophoblastic_tumor.vue": "6x04",
	"./Onco/Appendiceal_neuroendocrine_tumor.vue": "/cwO",
	"./Onco/Appendiceal_tumor.vue": "H0yA",
	"./Onco/Asparagine.vue": "C/qB",
	"./Onco/Aspartic_Acid.vue": "P2W+",
	"./Onco/BCLC.vue": "07+x",
	"./Onco/Basophil_Absolute_Count.vue": "4Jwm",
	"./Onco/Basophils.vue": "RpOi",
	"./Onco/Bismuth_Corlette.vue": "kR72",
	"./Onco/BladderTumor_TNM.vue": "8UOy",
	"./Onco/BreastCancerRAndT.vue": "gmqZ",
	"./Onco/BreastLobeTumor.vue": "U2cD",
	"./Onco/BreastSarcoma_TNM.vue": "liDk",
	"./Onco/Breast_Cancer_TNM.vue": "DFPC",
	"./Onco/Cancer_Antigen_125.vue": "KszY",
	"./Onco/Cancer_Antigen_15_3.vue": "2kwj",
	"./Onco/Cancer_of_anal_canal.vue": "CLd2",
	"./Onco/Carbohydrate_Antigen_19_9.vue": "ydIi",
	"./Onco/Carbohydrate_Antigen_seven_four.vue": "n6G1",
	"./Onco/Carboplatin_Dose.vue": "OPdi",
	"./Onco/Carcinoembryonic_Antigen.vue": "ZTSQ",
	"./Onco/Ceruloplasmin.vue": "3rvx",
	"./Onco/Cervix_carcinoma.vue": "SVB0",
	"./Onco/Chart_Karnofsky.vue": "EAIQ",
	"./Onco/Chemotherapy_WHO.vue": "phaV",
	"./Onco/Colorectal_cancer.vue": "WhTN",
	"./Onco/Conjunctival_carcinoma.vue": "xSUx",
	"./Onco/Conjunctival_melanoma.vue": "VaOb",
	"./Onco/Corpus_uteri_tumor.vue": "dk+L",
	"./Onco/Cutaneous_melanoma.vue": "A13o",
	"./Onco/Cytokeratin_19_Fragment.vue": "wv3w",
	"./Onco/Endometrial_cancer.vue": "SOef",
	"./Onco/EortcQLQC30.vue": "pdkc",
	"./Onco/Eosinophil_Cationic_Protein.vue": "vpJw",
	"./Onco/Eyelid_carcinoma.vue": "Pixr",
	"./Onco/FAB_classification_of_myelodysplastic_syndrome.vue": "Uw8a",
	"./Onco/Fallopian_tube_cancer.vue": "qYyc",
	"./Onco/Fallopian_tube_neoplasms.vue": "MzTq",
	"./Onco/Ferritin.vue": "eul8",
	"./Onco/Fuhrman.vue": "lhyL",
	"./Onco/GLeason_Score.vue": "VJtH",
	"./Onco/Gallbladder_sarcoma.vue": "un5d",
	"./Onco/Gastric_neuroendocrine_tumor.vue": "UY+B",
	"./Onco/Gastrointestinal_stromal_tumor.vue": "EeAr",
	"./Onco/Gestational_trophoblastic_tumor.vue": "MgUP",
	"./Onco/Grading_methods_for_immature_teratoma.vue": "SQvm",
	"./Onco/Growth_Differentiation_Factor_15.vue": "ZYUu",
	"./Onco/HPV_associated_oropharyngeal_cancer.vue": "hKCN",
	"./Onco/H_nHLymphoma.vue": "dwAA",
	"./Onco/Homocysteine.vue": "V/zC",
	"./Onco/Human_Epididymis_Protein_four.vue": "orHb",
	"./Onco/IntrahepaticBileDuct_TNM.vue": "mmo1",
	"./Onco/Jejunoileal_neuroendocrine_tumor.vue": "eB8C",
	"./Onco/Kappa_Light_Chain.vue": "Ctac",
	"./Onco/Kidney_cancer.vue": "46KQ",
	"./Onco/Laryngeal_neoplasm.vue": "W/q3",
	"./Onco/Lip_and_oral_cavity_neoplasm.vue": "YMVM",
	"./Onco/Localized_Prostate_Cancer_Risk_Grading.vue": "RzNG",
	"./Onco/LungCancer_TNM.vue": "aXso",
	"./Onco/MIPI_c.vue": "F+tF",
	"./Onco/Major_salivary_gland_tumor.vue": "XFwm",
	"./Onco/Malignant_melanoma_of_head_and_neck.vue": "2RCA",
	"./Onco/Mantle_cell_lymphoma.vue": "Y9u4",
	"./Onco/Medullary_thyroid_carcinoma.vue": "cn4X",
	"./Onco/Merkel_cell_tumor.vue": "IjNJ",
	"./Onco/Modified_Prognostic_Scoring_System_for_Trophoblastic_Tumor.vue": "liS+",
	"./Onco/Multiple_myeloma.vue": "BCNU",
	"./Onco/Neuroendocrine_tumors_of_duodenum_and_ampulla_of_Vater.vue": "/uKO",
	"./Onco/Neuron_Specific_Enolase.vue": "4Xij",
	"./Onco/Orbital_sarcoma.vue": "nDpA",
	"./Onco/Oropharyngeal_acancer.vue": "dVmS",
	"./Onco/OvarianCancer_Figo.vue": "QaIK",
	"./Onco/Ovarian_and_fallopian_tube_tumors_and_primary_peritoneal_cancer.vue": "NnF0",
	"./Onco/Pancreatic_endocrine_tumor.vue": "0cJ2",
	"./Onco/Pancreatic_neuroendocrine_tumors.vue": "/d6G",
	"./Onco/Parathyroid_carcinoma.vue": "cbuo",
	"./Onco/PelvisAndUretertumors_TNM.vue": "JXTh",
	"./Onco/PenileCancer_TNM.vue": "AXmG",
	"./Onco/PerformanceScore_KPS.vue": "t1gO",
	"./Onco/PerformanceScore_ZPS.vue": "Kc5C",
	"./Onco/Phyllodes_tumor_of_breast.vue": "GmWe",
	"./Onco/Postpubertal_sex_cord.vue": "1Ax8",
	"./Onco/PrimaryLiverCancer.vue": "VYxT",
	"./Onco/Pro_gastrin_releasing_peptide.vue": "EcDn",
	"./Onco/ProstateCancer_Gleason.vue": "RiXf",
	"./Onco/Prostate_cancer.vue": "0qf/",
	"./Onco/RMII.vue": "uznd",
	"./Onco/Retinoblastoma.vue": "HsgW",
	"./Onco/Retroperitoneal_soft_tissue_sarcoma.vue": "mw6V",
	"./Onco/Risk_grading_after_resection_of_gastrointestinal_stromal_tumors.vue": "rkNy",
	"./Onco/SIN_VIN.vue": "SCyF",
	"./Onco/Small_intestinal_neoplasm.vue": "fKzJ",
	"./Onco/Soft_tissue_sarcoma.vue": "HLVG",
	"./Onco/Soft_tissue_sarcoma_of_abdominal_and_thoracic_visceral_organs.vue": "U0sP",
	"./Onco/SolidTumor.vue": "zz2M",
	"./Onco/Squamous_Cell_Carcinoma.vue": "j0Eb",
	"./Onco/Syringomyelia.vue": "QTW8",
	"./Onco/TNMHilarCholangiocarcinoma.vue": "XxzA",
	"./Onco/Testicular_neoplasm.vue": "mETw",
	"./Onco/Thymic_tumor.vue": "yaIf",
	"./Onco/UCLA_Comprehensive_Staging_System_for_Renal_Cancer.vue": "rH0p",
	"./Onco/Uterine_sarcoma.vue": "zqkN",
	"./Onco/VaginalCancer_FIGO.vue": "kuNb",
	"./Onco/VaginalCancer_TNM.vue": "IXRZ",
	"./Onco/VulvarCancer_FIGO.vue": "lEa7",
	"./Onco/VulvarCancer_TNM.vue": "UL8F",
	"./Onco/a1_acid_glycoprotein.vue": "cMdS",
	"./Onco/gallbladder_carcinoma.vue": "j62T",
	"./Onco/gallbladder_carcinoma_test.vue": "vzo0",
	"./Onco/nasal_cavity_and_paranasal_sinus_tumors.vue": "gbHO",
	"./Orthopaedics/Clavicle_fracture_classification.vue": "1AhM",
	"./Orthopaedics/Denis_classification_of_spinal_fractures.vue": "Ij+L",
	"./Orthopaedics/Distal_Radius_Fracture_Grade.vue": "Kmub",
	"./Orthopaedics/Distal_Radius_Fractures_Lidstrom_Scale.vue": "lym1",
	"./Orthopaedics/Elbow_HSS_score.vue": "28XY",
	"./Orthopaedics/Eyres_Brooks_classification_of_scapular_coracoid_process.vue": "n59t",
	"./Orthopaedics/Ferguson_classification_of_flexion_compression_fractures.vue": "Uo3l",
	"./Orthopaedics/HSS_score_of_knee.vue": "6SiQ",
	"./Orthopaedics/Lateral_condyle_fracture_classification.vue": "W/li",
	"./Orthopaedics/Letournel_Judet_classification_of_acetabular_fractures.vue": "c3Y+",
	"./Orthopaedics/Low_back_pain_surgical_scoring_criteria.vue": "QLCu",
	"./Orthopaedics/Mason_Classification_of_Radial_Head_Fractures.vue": "xV5S",
	"./Orthopaedics/Mechanism_classification_of_humeral_intercondylar_fracture.vue": "/SiA",
	"./Orthopaedics/Modified_EIlis_Classification_of_Tibial_Fractures.vue": "ZBcm",
	"./Orthopaedics/Neer_classification_of_proximal_humeral_fractures.vue": "0Osb",
	"./Orthopaedics/Osteoporosis_Risk_One_Minute_Question.vue": "po7L",
	"./Orthopaedics/Osteoporosis_Self_Screening_Tool_for_Asians.vue": "U2Cw",
	"./Orthopaedics/Perilunate_dislocation_classification.vue": "5j9X",
	"./Orthopaedics/Radial_Head_Fractures_Hotchkiss_Classification.vue": "WZWE",
	"./Orthopaedics/Rockwood_classification_of_acromioclavicular_joint_dislocation.vue": "LXsK",
	"./Orthopaedics/Schatzker_classification_of_tibial_plateau_fractures.vue": "AKOe",
	"./Pedi/Alvarado.vue": "2znG",
	"./Pedi/BATiC.vue": "Oct9",
	"./Pedi/BSA.vue": "Y1LY",
	"./Pedi/BowelLength.vue": "cwos",
	"./Pedi/CATCH.vue": "ssIk",
	"./Pedi/Comfort.vue": "lRaL",
	"./Pedi/ComplementaryFoodsToInfants.vue": "lmBA",
	"./Pedi/DCFC_Age.vue": "XViA",
	"./Pedi/DCFC_BSA.vue": "xMiZ",
	"./Pedi/DCFC_Weight.vue": "RK3H",
	"./Pedi/DOWNE_score_for_neonatal_respiration.vue": "s44Q",
	"./Pedi/GHD.vue": "nx/M",
	"./Pedi/Galactose.vue": "bexs",
	"./Pedi/GlasgowComaScale.vue": "Q2Fh",
	"./Pedi/GlasgowComaScalePed.vue": "lLii",
	"./Pedi/HeadCircumferenceAndAgePercentileOfInfants.vue": "sFnG",
	"./Pedi/HeightAndAgePercentileOfInfants.vue": "3oqD",
	"./Pedi/HeightAndHeightPercentileOfInfants.vue": "Y1rY",
	"./Pedi/HydroxyprolineInUrine.vue": "9Vb9",
	"./Pedi/IDOPEI.vue": "TPHJ",
	"./Pedi/InfantHeartFailureGradingScale.vue": "drl3",
	"./Pedi/InfantNutrientNeeds.vue": "tSCT",
	"./Pedi/KDCriteria.vue": "C+J7",
	"./Pedi/Kocher.vue": "IUy7",
	"./Pedi/L_T4_Child.vue": "tXkF",
	"./Pedi/LaryngealObstruction.vue": "07xw",
	"./Pedi/MaintenanceFluidPed.vue": "vbC6",
	"./Pedi/NYU_PHFI.vue": "nhTq",
	"./Pedi/Neonatal_shock_scale.vue": "Vzy+",
	"./Pedi/PECARN.vue": "7Wxe",
	"./Pedi/PELD.vue": "1Rxn",
	"./Pedi/PRAM.vue": "308y",
	"./Pedi/PediatricTraumaScore.vue": "ewS3",
	"./Pedi/PediatricTubeSize.vue": "PN/2",
	"./Pedi/Phenylalanine.vue": "VHvD",
	"./Pedi/RateOfWeightGainInPretermInfants.vue": "xckx",
	"./Pedi/SGAAS.vue": "ioFJ",
	"./Pedi/StageOfChildrenAge.vue": "be7i",
	"./Pedi/TargetHeight.vue": "iVLg",
	"./Pedi/TubularPhosphateReabsorption.vue": "jW+J",
	"./Pedi/UmbilicalLine.vue": "GJXm",
	"./Pedi/UrineOutput.vue": "GFut",
	"./Pedi/WETFAG.vue": "4MFn",
	"./Pedi/WeightAndAgePercentileOfInfants.vue": "yz7q",
	"./Pedi/WestleyCroup.vue": "0p4l",
	"./Pulm/ADO.vue": "kC8i",
	"./Pulm/AaGradientAndRatio.vue": "/WO6",
	"./Pulm/ArtOxygenDifference.vue": "fac0",
	"./Pulm/BODEx.vue": "+jgU",
	"./Pulm/CRB65.vue": "kqTF",
	"./Pulm/CURB65.vue": "Mn43",
	"./Pulm/Chart_Borg.vue": "bb8h",
	"./Pulm/Chart_BorgCR10.vue": "ysGq",
	"./Pulm/Chart_GOLD.vue": "cbVQ",
	"./Pulm/Chart_MMRCdyspnea.vue": "CP+U",
	"./Pulm/Chart_MRCdyspnea.vue": "FY9R",
	"./Pulm/Epworth.vue": "F+lS",
	"./Pulm/GAS_Centor.vue": "GIH8",
	"./Pulm/HendersonHasselbalch.vue": "pWDt",
	"./Pulm/Hestia.vue": "r5Bp",
	"./Pulm/InFlightPaO2.vue": "SakR",
	"./Pulm/Intrapulmonary_right_to_left_shunt.vue": "mozV",
	"./Pulm/LungAge.vue": "eYUO",
	"./Pulm/MurrayLungInjuryScore.vue": "55zQ",
	"./Pulm/OxygenIndex.vue": "m199",
	"./Pulm/PSI.vue": "Y7pH",
	"./Pulm/PaO.vue": "rjr7",
	"./Pulm/PaO2FiO2ratio.vue": "L+2c",
	"./Pulm/PaduaScore.vue": "w2ps",
	"./Pulm/PredictedBodyWeightARDS.vue": "1eDN",
	"./Pulm/PredictedPeakFlow.vue": "Pgho",
	"./Pulm/SolitaryNodule.vue": "U9/q",
	"./Pulm/SpirometricValues.vue": "DHC4",
	"./Pulm/Theophylline.vue": "nyo2",
	"./Pulm/VWindicators.vue": "I1T/",
	"./Pulm/VentilationBloodFlowRatio.vue": "TzWP",
	"./Pulm/sPESI.vue": "Zaoj",
	"./RI/AIHSDC.vue": "DCvE",
	"./RI/Absolute_Monocyte_Count.vue": "BnBV",
	"./RI/AcrEular.vue": "uJQN",
	"./RI/Anti_Cyclic_Citrullinated_Peptide_Antibodies.vue": "yDX0",
	"./RI/Antithyroid_peroxidase_antibody.vue": "+Jkw",
	"./RI/BehcetDisease.vue": "NTnr",
	"./RI/Boolean2criteria.vue": "Xzyl",
	"./RI/CCFRA.vue": "htlf",
	"./RI/Classificationcriteriaforfunctionalstatusofrheumatoidarthritisjoints.vue": "+KTc",
	"./RI/ClassificationcriteriaofrheumatoidarthritisbyXrays.vue": "vWHS",
	"./RI/Complement_Component_four.vue": "R9J4",
	"./RI/Complement_Component_three.vue": "t0xV",
	"./RI/DiagnosticCriteriaofAnkylosingspondylitis.vue": "bJqA",
	"./RI/DiagnosticCriteriaofOsteoarthritisofhands.vue": "/leY",
	"./RI/DiagnosticCriteriaofOsteoarthritisofknees.vue": "ju8r",
	"./RI/Eosinophil.vue": "O7mG",
	"./RI/GoutClassificationCriteria.vue": "3yht",
	"./RI/IAIHG.vue": "MN6g",
	"./RI/Immunoglobulin_G.vue": "NMyu",
	"./RI/Immunoglobulin_M.vue": "OvKc",
	"./RI/Lymphocyte.vue": "GU09",
	"./RI/Lymphocyte_Absolute_Count.vue": "hSBc",
	"./RI/Monocytes.vue": "qNXV",
	"./RI/SLA.vue": "+u34",
	"./RI/SSDAI.vue": "hIUc",
	"./RI/STAR.vue": "OZTz",
	"./RI/TheYamaguchiDiagnosticCriteriaofAdultonsetStill.vue": "QvxM",
	"./RI/UA.vue": "/AlB",
	"./Renal/AdrenalTumorStage.vue": "yvh9",
	"./Renal/AnionGap.vue": "8Xd4",
	"./Renal/ArterialBloodGas.vue": "lMYT",
	"./Renal/CaCorrection_Albumin.vue": "5O9t",
	"./Renal/CaCorrection_Protein.vue": "GpkI",
	"./Renal/Chart_RIFLE.vue": "6zyv",
	"./Renal/ChronicKidneyDisease_CKD.vue": "0dwv",
	"./Renal/DialysisEffe.vue": "MfX5",
	"./Renal/ExcretionFraction_Ca.vue": "pkFr",
	"./Renal/ExcretionFraction_Mg.vue": "AGC4",
	"./Renal/FEUrea.vue": "q59y",
	"./Renal/IronDeficiency.vue": "8Fen",
	"./Renal/KDIGOAKI.vue": "QDbA",
	"./Renal/NaCorrection_Albumen.vue": "AAYX",
	"./Renal/NaCorrection_Sugar.vue": "6jSc",
	"./Renal/NaRevise.vue": "opko",
	"./Renal/ProteinExcretion.vue": "gidm",
	"./Renal/RIFLEGrade.vue": "19c7",
	"./Renal/RenalFailure.vue": "IWY4",
	"./Renal/SerumSodiumCorrected.vue": "hbMe",
	"./Renal/Unit_conversionOfCreatinine.vue": "PBrE",
	"./Trauma/ABSI.vue": "5ZZQ",
	"./Trauma/Burn.vue": "lL6b",
	"./Trauma/BurnDeep.vue": "tcS2",
	"./Trauma/BurnFluidReplacement.vue": "wfdO",
	"./Trauma/BurnNutrition.vue": "aqRV",
	"./Trauma/CPOT.vue": "ocWZ",
	"./Trauma/CanadianCSpine.vue": "MKcj",
	"./Trauma/CanadianCTHeadRule.vue": "59xB",
	"./Trauma/Chart_AVPU.vue": "wYUU",
	"./Trauma/Chart_BurnTBSA.vue": "A2D0",
	"./Trauma/Chart_NACA.vue": "8SdQ",
	"./Trauma/Chart_Teeth.vue": "z0Pk",
	"./Trauma/EvansBrooke.vue": "jNWK",
	"./Trauma/FOUR.vue": "MDka",
	"./Trauma/ISS.vue": "G3oN",
	"./Trauma/NewOrleans.vue": "TnW8",
	"./Trauma/NexusCSpine.vue": "BIHy",
	"./Trauma/NexusIIHeadCT.vue": "BOyc",
	"./Trauma/OttawaAnkleRule.vue": "VncD",
	"./Trauma/OttawaKneeRule.vue": "tud6",
	"./Trauma/OxygenTankRemainingTime.vue": "oKkY",
	"./Trauma/RevisedTraumaScore.vue": "wmRW",
	"./Trauma/TASH.vue": "M9PZ",
	"./Trauma/WFNS.vue": "jXDm",
	"./Trauma/Weir.vue": "QRK1",
	"./Urology/Beta_2_Microglobulin.vue": "yoSG",
	"./Urology/BladderCancer_TNM.vue": "fZjLD",
	"./Urology/BladderUrothelialCarcinoma.vue": "r834",
	"./Urology/Chloride.vue": "BXfn",
	"./Urology/Free_PSA.vue": "xWlo",
	"./Urology/GFR_CKD_EPI.vue": "00Mr",
	"./Urology/LocalizedProstateCancer.vue": "lI66",
	"./Urology/Luteinizing_Hormone.vue": "aW8x",
	"./Urology/StagingOfDiaNep.vue": "IrK2",
	"./Urology/Testosterone.vue": "TjNs",
	"./Urology/UrethralTumor_TNM.vue": "oJhx",
	"./Urology/a1_Microglobulin.vue": "403q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y+gd";


//////////////////
// WEBPACK FOOTER
// ./src/pages/formulas \.vue$
// module id = Y+gd
// module chunks = 2